/**
 * Plugin Popup notification
 * created by CVCUONG1 10/12/2020
 */
import Popup from "./MsPopupNotification.vue";
Popup.install = (Vue, options = {}) => {
    let MyComponent = Vue.extend({
        render: h => {
            return h(Popup,{
                props: {
                    options: options
                },
                ref: "Popup"
            })
        }
    })
    var component = new MyComponent().$mount()
    document.body.appendChild(component.$el)
    Vue.prototype.$popup = component.$refs.Popup
}
export default Popup;